<template>
  <div class="kins-folk-wrapper">
    <div class="kins-pop-title">编辑亲属信息</div>

    <div>
      <el-form ref="kinsFolkForm" :model="kinsFolkForm" :rules="formRules" label-width="70px">    
        <el-form-item label="姓名：" prop="name">
          <el-input size="small" v-model.trim="kinsFolkForm.name" maxlength="10" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-select v-model="kinsFolkForm.sex" size="small" placeholder="请选择">
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄：" prop="age">
          <el-input size="small" v-model.trim="kinsFolkForm.age" maxlength="3" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align:center">
      <el-button size="small" @click="handleCancel">取 消</el-button>
      <el-button size="small" type="primary" @click="handleSave">保 存</el-button>
    </div>
  </div>
</template>
<script>
import {
  saveOrUpdatePatientRelative,
  getRelativeByPatientId
} from "@/api/Patientmanagement.js";
import local from '@/utils/local.js'
export default {
  props: {
    showKinsPop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      saveFlag: true,
      kinsFolkForm: {
        name: '',
        sex: null,
        age: null,
        // archivesId: null,
        id: null
      },
      formRules:{
        name: [
          { required: true, message: "请填写姓名", trigger: "blur" }
        ],
        age: [
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: ['change', 'blur']}
        ]
      }
    }
  },
  async created() {
    this.getKinsFolk()
  },
  mounted() {},
  methods: {
    async getKinsFolk() {
      let res = await getRelativeByPatientId({
        patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId
      })
      if (res.code == 0 && res.data) {
        this.kinsFolkForm = res.data
      }
    },
    handleCancel() {
      this.$emit('update:showKinsPop', false)
    },
    async handleSave() {
      let valRes
      this.$refs.kinsFolkForm.validate(val => {
        valRes = val
      })
      if (!valRes) {
        return
      }

      if (!this.saveFlag) return
      this.saveFlag = false
      saveOrUpdatePatientRelative({
        ...this.kinsFolkForm,
        archivesId: sessionStorage.getItem("archivesId"),
        patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId
      }).then(res=>{
        if(res.code == 0){
          this.$message.success('保存成功')
          this.$emit('update:showKinsPop', false)
          this.$emit('recieveRelative', this.kinsFolkForm.id ? this.kinsFolkForm : res.data)
        }
        this.saveFlag = true
      }).catch(e => {
        this.saveFlag = true
      })

      // let res = await saveOrUpdatePatientRelative({
      //   ...this.kinsFolkForm,
      //   archivesId: sessionStorage.getItem("archivesId"),
      //   patientId: JSON.parse(sessionStorage.getItem('patientInfo')).patientId
      // })
      // if (res.code == 0) {
      //   this.$message.success('保存成功')
      //   this.$emit('update:showKinsPop', false)
      //   this.$emit('recieveRelative', this.kinsFolkForm.id ? this.kinsFolkForm : res.data)
      // }
    }
  }
};
</script>
<style lang="less" scoped>
.kins-folk-wrapper {
  padding: 30px;
  width: 328px;
  // height: 292px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px -4px rgba(0,0,0,0.12), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 9px 28px 8px rgba(0,0,0,0.05);
  border-radius: 2px;
  .kins-pop-title {
    font-size: 14px;
    font-weight: 700;
    color: rgba(0,0,0,0.85);
    text-align: center;
    margin-bottom: 20px;
    line-height: 20px;
  }
  /deep/.el-form-item__label {
    font-size: 12px;
  }
}
</style>